<div class="chart-container" >
    <canvas id="chart" class="chart">{{ chart }}</canvas>
</div>